import {
  CardStatusEnum,
  CardTypeEnum,
  InlineAlertType,
} from '@varo/graphql-schema-types';
import { CardExpirationStatusEnum } from 'features/cardManagement/helpers/CardExpirationStatusEnum';
import { TFunction } from 'i18next';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ButtonProps } from 'shared/components/vxl/Button/Button';
import InlineAlert from 'shared/components/vxl/InlineAlert/InlineAlert';
import theme from 'shared/styles/theme';

export const CardAlert = ({
  cardType,
  cardStatus,
  cardExpiryStatus,
  shouldShowSetPinAction,
  translatedText,
  onClick,
}: {
  cardType: CardTypeEnum;
  cardStatus: CardStatusEnum;
  cardExpiryStatus: CardExpirationStatusEnum;
  shouldShowSetPinAction: boolean;
  translatedText: TFunction;
  onClick?: (() => void) | null;
}) => {
  const getAlertText = (cardStatus: CardStatusEnum) => {
    let title = translatedText('pinAlert.title');
    let info = translatedText('pinAlert.info');

    if (cardStatus === CardStatusEnum.New) {
      title = translatedText('digitalCardAlert');
      info = '';
    } else if (cardStatus === CardStatusEnum.Suspended) {
      title = translatedText('suspendedAlert.title');
      switch (cardType) {
        case CardTypeEnum.DebitCard:
          info = translatedText('suspendedAlert.debitAlertInfo');
          break;
        case CardTypeEnum.ChargeCard:
          info = translatedText('suspendedAlert.believeAlertInfo');
          break;
      }
    }

    if (cardExpiryStatus === CardExpirationStatusEnum.Expired) {
      title = translatedText('expiredAlert.title');
      info = translatedText('expiredAlert.message');
    }

    return { title, info };
  };

  const shouldShowBanner =
    cardStatus === CardStatusEnum.New ||
    cardStatus === CardStatusEnum.Suspended ||
    cardExpiryStatus === CardExpirationStatusEnum.Expired ||
    shouldShowSetPinAction;

  let button: ButtonProps | undefined = undefined;

  if (cardExpiryStatus === CardExpirationStatusEnum.Expired) {
    button = {
      label: translatedText('expiredAlert.button'),
      onPress: onClick,
      type: 'SECONDARY_ALT',
    };
  } else if (shouldShowSetPinAction) {
    button = {
      label: translatedText('banner.pin.createPin'),
      onPress: onClick,
      type: 'SECONDARY_ALT',
    };
  }

  const isErrorType =
    cardStatus === CardStatusEnum.Suspended ||
    cardExpiryStatus === CardExpirationStatusEnum.Expired;

  return shouldShowBanner ? (
    <View style={styles.alert}>
      <InlineAlert
        alertType={isErrorType ? InlineAlertType.Error : InlineAlertType.Info}
        button={button}
        bodyText={getAlertText(cardStatus).info}
        iconKeyType={isErrorType ? 'ERROR' : 'INFO'}
        titleText={getAlertText(cardStatus).title}
      />
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  alert: {
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
  },
});
